// Angular
import { Component, Input } from '@angular/core';

import { ResourceTab } from '../../../../../../../../../state/modules/resource/resource-api.model';

@Component({
  standalone: false,
  selector: 'kt-location-resources-view',
  templateUrl: './location-resources-view.component.html',
  styleUrls: ['./location-resources-view.component.scss']
})
export class LocationResourcesViewComponent {
  @Input() locationId: number;
  @Input() tab: ResourceTab = 'resources';
}
